











































































































import { Component, Prop, Vue } from "vue-property-decorator";
import NavBar from "../components/NavBar.vue";
import LoadingButton from "../components/LoadingButton.vue";
import MHButton from "../components/MHButton.vue";
import Action from "../store/actionTypes";

@Component({
  components: {
    NavBar,
    LoadingButton,
    MHButton 
  }
})
export default class Login extends Vue {
  private email: string = "";

  private password: string = "";
  private error: string = "";
  private loading: boolean = false;

  onSubmit(evt: Event) {
    evt.preventDefault();
    this.loading = true;
    this.$store
      .dispatch("LOGIN", {
        email: this.email,
        password: this.password
      })
      .then(
        _ => {
          this.$router.push({
            path: "statements"
          });
        },
        error => {
          this.error = error.response.data.message;
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }
  hasError() {
    return this.error.length > 0;
  }
  signup() {
    this.$router.push({
      path: "signup"
    });
  }
}
